import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';

function MalzemeSearch({ setMalzeme, value, searchParam, error, setProduct}) {
  const [openMalzeme, setOpenMalzeme] = React.useState(false);
  const [optionsMalzeme, setOptionsMalzeme] = React.useState([]);
  const loadingMalzeme = openMalzeme && optionsMalzeme.length === 0;
  const [searchMalzeme, setSearchMalzeme] = React.useState('');
  const { t } = useTranslation('overview');

  React.useEffect(() => {
    let active = true;
    if (searchMalzeme.length > 0 && openMalzeme) {
      axios
        .get(
          `/GetMaterialWorkCaseSearch/${searchMalzeme.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)}/${setProduct}`
        )
        .then(res => {
          if (active) {
            if (res.data.length > 0) {
              setOptionsMalzeme(res.data);
            } else {
              setOptionsMalzeme([]);
            }
          }
        })
        .catch(err => {
          setOptionsMalzeme([]);
        });
    }
    return () => {
      active = false;
    };
  }, [searchMalzeme, openMalzeme, loadingMalzeme]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setSearchMalzeme(searchParam);
    }
  }, [searchParam]);

  const updateMalzeme = malzeme => {
    setMalzeme(malzeme);
    value.Material = malzeme.Material;
    value.MaterialCode = malzeme.MaterialCode;
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={openMalzeme}
      value={value}
      onOpen={() => {
        setOpenMalzeme(true);
      }}
      onClose={() => {
        setOpenMalzeme(false);
      }}
      getOptionLabel={option => {
        return option.MaterialCode
          ? `${option.MaterialCode} - ${option.Material}`
          : '-';
      }}
      options={optionsMalzeme}
      filterOptions={(optionsMalzeme, state) => optionsMalzeme}
      loading={loadingMalzeme}
      onChange={(event, newValueMalzeme) => {
        if (newValueMalzeme && newValueMalzeme.Material) {
          updateMalzeme(newValueMalzeme);
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          onChange={e => {
            setSearchMalzeme(e.target.value);
          }}
          variant="outlined"
          size="small"
          label={t('lblMaterial')}
          helperText={value ? value.Material : ''}
          error={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loadingMalzeme ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}

export default MalzemeSearch;
